const mapInstances = new Map([
  ["Array", Array],
  ["File", File]
]);

export { mapInstances };
